<template>
  <MurmurList/>
</template>

<script>
// 標準モジュール
import { useRouter } from 'vue-router';

// 外部モジュール

// 独自モジュール
import MurmurList from '@/components/murmurs/MurmurList.vue'

export default {
  name: 'MurmurTop',
  components: {
    MurmurList,
  },
  setup() {
    const router = useRouter()

    const openPage = (target) => {
      router.push(`/${target}`)
    }
    
    return {
      openPage,
    };
  },
}
</script>
